import type { ComponentType } from 'react'

export const lazyRoute =
  <T>(
    loadModule: () => Promise<T>,
    getComponent: (module: T) => ComponentType
  ) =>
  async () => ({ Component: getComponent(await loadModule()) })
